/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Card, Stack, FormControlLabel, Checkbox, Box, Pagination } from '@mui/material';
import CardConfig from 'components/CardConfig';
import TextInput from 'components/input/textInput';
import { useFormik } from 'formik';
import React, { ReactNode } from 'react';
import { Col, Dropdown, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import collegeServices, { MyCollegesRecord } from 'services/collegeServices';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import LoadingContent from 'components/LoadingContent';
import SavingIndicator from 'screen/CollegeManagement/SavingIndicator';
import { checkEnableParseJSON } from 'components/helper/helper';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import TuneOutlinedIcon from '@mui/icons-material/TuneOutlined';
import DeviceHubOutlinedIcon from '@mui/icons-material/DeviceHubOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import ModalMajor from 'screen/CollegeManagement/ModalMajor';
import ModalLocation from 'screen/CollegeManagement/ModalLocation';
import ModalCampusLife from 'screen/CollegeManagement/ModalCampusLife';
import ModalAdmissionRequirement from 'screen/CollegeManagement/ModalAdmissionRequirement';
import ModalCollegeInfo from 'screen/CollegeManagement/ModalCollegeInfo';
import { useParams } from 'react-router-dom';
import { useAppSelector } from 'app/hooks';
import SelectInput from 'components/input/SelectInput';
export const typoSx = {
  title: {
    fontWeight: 700,
    fontSize: 20,
  },
};

type TCollege = {
  url_price_calc?: string;
  counselor_ranking?: string;
  act: string;
  address_line_1: string;
  address_line_2: string;
  area_code_1: string;
  area_code_2: string;
  area_code_fax: string;
  city: string;
  cmps_setting: string;
  college_id: number;
  country_code: string;
  county: string;
  difficulty_for_admittance: string;
  founding_year: number;
  hous_frsh_policy: string;
  id: number;
  life_frat_nat: string;
  life_sor_nat: string;
  name: string;
  phone_number_1: string;
  phone_number_2: string;
  phone_number_fax: string;
  region: string;
  size_of_school: string;
  state: string;
  state_name: string;
  under_student: number;
  url_address: string;
  year_type: string;
  zip_code: string;
  is_saved: boolean;
  gpa?: number;
  sat?: number | string;
  type_of_school?: string;
};

export type ListCollegeByGroup = {
  name: string;
  collegeList: TCollege[];
}[];

const CounselorCollegeSearch = () => {
  const params: { id?: string | number } = useParams();

  const [openMajorSearch, setOpenMajorSearch] = React.useState(false);
  const [openLocationSearch, setOpenLocationSearch] = React.useState(false);
  const [openCollegeInfo, setOpenCollegeInfo] = React.useState(false);
  const [openCampusLife, setOpenCampusLife] = React.useState(false);
  const [openAdmissionRequirement, setOpenAdmissionRequirement] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [totalPage, setTotalPage] = React.useState(40);
  const [myCurrentList, setMyCurrentList] = React.useState<ListCollegeByGroup>([]);
  const [data, setData] = React.useState<any>(null);
  const [colleges, setColleges] = React.useState<TCollege[]>([]);
  const [openModal, setOpenModal] = React.useState<TCollege | undefined | null>();
  const [loading, setLoading] = React.useState(false);
  const [loadingLists, setLoadingLists] = React.useState(true);
  const [saving, setSaving] = React.useState(false);
  const formik = useFormik({
    initialValues: {
      keyword: '',
      state_name: '',
      major_names: [],
      state_codes: [],
      cmps_setting: [],
      size_of_school: [],
      life_frat_nat: '',
      life_sor_nat: '',
      from_gpa: null,
      to_gpa: null,
      from_sat: null,
      to_sat: null,
      from_act: null,
      to_act: null,
      region: null as any,
      type_of_school: [],
      year_types: [],
    },
    onSubmit: async (val) => {
      setPage(1);
      searchCollege(val, 1);
    },
  });

  const searchCollege = async (filter: any, pageNumberInput: number) => {
    setLoading(true);
    const [res, total]: any = await collegeServices.getUSCollegeV1({
      life_frat_nat:
        filter?.life_frat_nat === 'true'
          ? 'Y'
          : filter?.life_frat_nat === 'false'
          ? 'N'
          : filter?.life_frat_nat,
      life_sor_nat:
        filter?.life_sor_nat === 'true'
          ? 'Y'
          : filter?.life_sor_nat === 'false'
          ? 'N'
          : filter?.life_sor_nat,
      take: 100,
      skip: (pageNumberInput - 1) * 100,
      type_of_schools: filter.type_of_school?.length ? filter.type_of_school : undefined,

      regions: filter.region,
      keyword: filter.keyword,
      state_codes: filter.state_codes,
      state_name: filter.state_name,
      cmps_settings: filter.cmps_setting ? filter.cmps_setting : undefined,
      sizes_of_school: filter.size_of_school?.length ? filter.size_of_school : undefined,

      sport_codes: filter.sport_codes,
      major_names: filter.major_names,
      from_gpa: filter.from_gpa,
      to_gpa: filter.to_gpa,
      from_sat: filter.from_sat,
      to_sat: filter.to_sat,
      from_act: filter.from_act,
      to_act: filter.to_act,
      year_types: filter.year_types?.length ? filter.year_types : undefined,
    });
    setColleges(res);
    setTotalPage(Math.ceil(total / 100));
    setLoading(false);
  };
  const menu = useAppSelector((store) => store.counselor.studentList);
  // eslint-disable-next-line eqeqeq
  const student = (menu ?? []).find((item) => item?.student_id == params?.id)?.student_info;
  const studentName = [student?.first_name, student?.last_name].join(' ');
  React.useEffect(() => {
    if (!params?.id) return;
    setLoadingLists(true);
    collegeServices
      .getMyCollege(params.id)
      .then((res: any) => {
        const parsed = res?.colleges_array
          ? checkEnableParseJSON(res.colleges_array, [])
          : [];
        setMyCurrentList(Array.isArray(parsed) ? parsed : []);
        setData(res);
      })
      .finally(() => setLoadingLists(false));
  }, [params?.id]);
  React.useEffect(() => {
    searchCollege(formik.values, page);
  }, [page]);

  const persistMyColleges = async (list: any[], dataInput: any) => {
    if (!params?.id) return;
    setSaving(true);
    try {
      // After UNIFY-COLLEGES-001, getMyCollege no longer returns a DB row `id`
      // (payload is rebuilt from student_school_picks). Use existing list content
      // to decide create vs update so we don't always toast "create".
      const existingGroups = dataInput?.colleges_array
        ? checkEnableParseJSON(dataInput.colleges_array, [])
        : [];
      const hasExistingPicks =
        !!dataInput?.id ||
        (Array.isArray(existingGroups) &&
          existingGroups.some(
            (g: any) => Array.isArray(g?.collegeList) && g.collegeList.length > 0
          ));

      if (hasExistingPicks) {
        await collegeServices.updatetMyCollege(params.id, JSON.stringify(list));
      } else {
        await collegeServices.createMyCollege(params.id, JSON.stringify(list));
      }
      const fresh: MyCollegesRecord = await collegeServices.getMyCollege(params.id);
      const parsed = fresh.colleges_array
        ? checkEnableParseJSON(fresh.colleges_array, [])
        : [];
      setMyCurrentList(Array.isArray(parsed) ? parsed : []);
      setData(fresh);
    } finally {
      setSaving(false);
    }
  };

  const handleClickAddToList = (
    item: TCollege,
    currentListItem: {
      name: string;
      collegeList: TCollege[];
    }
  ) => {
    // ClickUp 86ajtw2vj: counselor lists start with Save to My Colleges OFF.
    // Only checking the box (is_saved: true) puts the school on the student's My Colleges.
    const collegeToAdd = { ...item, is_saved: false };
    const newMyCurrentList = myCurrentList.map((list) => {
      return list.name === currentListItem.name
        ? {
            name: list.name,
            collegeList: [...list.collegeList, collegeToAdd].filter(
              (college, collegeIndex, arr) => {
                return (
                  arr.findLastIndex((col: TCollege) => col.id === college.id) === collegeIndex
                );
              }
            ),
          }
        : list;
    });

    setMyCurrentList(newMyCurrentList);
    if (!loadingLists && data !== null) {
      void persistMyColleges(newMyCurrentList, data);
    }
  };

  const handleAddNewList = (name: string, item: TCollege | undefined | null) => {
    if (!!name && !!item && myCurrentList.findIndex((list) => list.name === name) !== -1) {
      handleClickAddToList(
        item,
        myCurrentList[myCurrentList.findIndex((list) => list.name === name)]
      );
      setOpenModal(null);
      return;
    }
    if (item) {
      const newMyCurrentList = [
        ...myCurrentList,
        { name, collegeList: [{ ...item, is_saved: false }] },
      ];
      setMyCurrentList(newMyCurrentList);
      if (!loadingLists && data !== null) {
        void persistMyColleges(newMyCurrentList, data);
      }
    }
    setOpenModal(null);
  };

  const handleRemoveSchool = (item: TCollege, listName: string) => {
    const newMyCurrentList = myCurrentList.map((list) => {
      return list.name === listName
        ? {
            name: list.name,
            collegeList: list.collegeList.filter((college) => college.id !== item.id),
          }
        : list;
    });
    setMyCurrentList(newMyCurrentList);
    if (!loadingLists && data !== null) {
      void persistMyColleges(newMyCurrentList, data);
    }
  };
  const handleRemoveList = (index: number) => {
    const newMyCurrentList = myCurrentList.filter((list, i) => i !== index);
    setMyCurrentList(newMyCurrentList);
    if (!loadingLists && data !== null) {
      void persistMyColleges(newMyCurrentList, data);
    }
  };

  const handleCheckedItem = (item: TCollege, index: number, listName: string) => {
    const prev = myCurrentList
      .find((list) => list.name === listName)
      ?.collegeList?.[index];
    // Expanding the card mounts SelectInput and can fire a no-op onChange — do not
    // hit the update API unless ranking / is_saved actually changed.
    if (
      prev &&
      !!prev.is_saved === !!item.is_saved &&
      (prev.counselor_ranking || '') === (item.counselor_ranking || '')
    ) {
      return;
    }

    const newMyCurrentList = myCurrentList.map((list) => {
      let newListCollege = [...list.collegeList];
      newListCollege[index] = item;

      return list.name === listName
        ? {
            name: list.name,
            collegeList: newListCollege,
          }
        : list;
    });
    setMyCurrentList(newMyCurrentList);
    if (!loadingLists && data !== null) {
      void persistMyColleges(newMyCurrentList, data);
    }
  };

  let CampusCount =
    formik.values.cmps_setting.length +
    formik.values.size_of_school.length +
    (formik.values.life_frat_nat.length ? 1 : 0) +
    (formik.values.life_sor_nat.length ? 1 : 0);
  let AdmissionCount =
    (formik.values.from_gpa !== null || formik.values.to_gpa !== null ? 1 : 0) +
    (formik.values.from_sat !== null || formik.values.to_sat !== null ? 1 : 0) +
    (formik.values.from_act !== null || formik.values.to_act !== null ? 1 : 0);
  let InfoCount =
    (formik.values.type_of_school?.length > 11
      ? 2
      : formik.values.type_of_school?.length > 0
      ? 1
      : 0) + (formik.values?.year_types?.length ?? 0);
  let countLocation = formik.values.state_codes.length;
  return (
    <>
      <SavingIndicator saving={saving} loading={loadingLists} />
      <Container
        className="gm-basic-info-page" 
        style={{ paddingTop: '40px' }}
      >
        <div className="gm-section-card px-4">
          <Row>
            <TextInput
              mdCol={5}
              label=""
              name="keyword"
              placeholder="Search by Name"
              values={formik.values.keyword}
              onChange={formik.handleChange}
              otherProps={{
                onKeyPress: (ev: any) => {
                  if (ev.key === 'Enter') {
                    ev.preventDefault();
                    formik.handleSubmit();
                  }
                },
              }}
            />
            <TextInput
              mdCol={5}
              label=""
              placeholder="Search by City or State"
              name="state_name"
              values={formik.values.state_name}
              onChange={formik.handleChange}
              otherProps={{
                onKeyPress: (ev: any) => {
                  if (ev.key === 'Enter') {
                    ev.preventDefault();
                    formik.handleSubmit();
                  }
                },
              }}
            />
            <Col md={2} className='d-flex justify-content-end align-items-end'>
              <Button
                style={{ marginTop: '22px', width: '100%', height: '48px'}}
                onClick={() => formik.handleSubmit()}
              >
                Search
              </Button>
            </Col>
          </Row>
        {loading ? (
          <LoadingContent />
        ) : (
          <Box
            sx={{
              marginTop: '10px !important',
            }}
          >
            <Card className="p-2">
              <Stack direction="row" justifyContent={'center'} spacing={2} className="w-100 mb-3">
                <CardItem
                  icon={
                    <LocationOnOutlinedIcon
                      color="primary"
                      sx={{ fontSize: 26, marginBottom: 1 }}
                    />
                  }
                  onClick={() => setOpenLocationSearch((prev) => !prev)}
                  label={`Location ${countLocation ? `(${countLocation})` : ''}`}
                  onDelete={
                    countLocation > 0
                      ? () => {
                          formik.setFieldValue('state_codes', []);
                          formik.handleSubmit();
                        }
                      : null
                  }
                />
                <CardItem
                  icon={
                    <DeviceHubOutlinedIcon color="primary" sx={{ fontSize: 26, marginBottom: 1 }} />
                  }
                  onClick={() => setOpenMajorSearch((prev) => !prev)}
                  label={`Majors ${
                    formik.values.major_names.length > 0 ? `(${formik.values.major_names.length})` : ''
                  }`}
                  onDelete={
                    formik.values.major_names.length > 0
                      ? () => {
                          formik.setFieldValue('major_names', []);
                          formik.handleSubmit();
                        }
                      : null
                  }
                />
                <CardItem
                  icon={
                    <HolidayVillageOutlinedIcon
                      color="primary"
                      sx={{ fontSize: 26, marginBottom: 1 }}
                    />
                  }
                  onClick={() => setOpenCampusLife((prev) => !prev)}
                  label={`Campus Life ${CampusCount > 0 ? `(${CampusCount})` : ''}`}
                  onDelete={
                    CampusCount
                      ? () => {
                          formik.setValues({
                            ...formik.values,
                            cmps_setting: [],
                            size_of_school: [],
                            life_frat_nat: '',
                            life_sor_nat: '',
                          });
                          formik.handleSubmit();
                        }
                      : null
                  }
                />
                <CardItem
                  icon={<TuneOutlinedIcon color="primary" sx={{ fontSize: 26, marginBottom: 1 }} />}
                  onClick={() => setOpenAdmissionRequirement((prev) => !prev)}
                  label={`Admission Requirements ${
                    AdmissionCount > 0 ? `(${AdmissionCount})` : ''
                  }`}
                  onDelete={
                    AdmissionCount
                      ? () => {
                          formik.setValues({
                            ...formik.values,
                            from_gpa: null,
                            to_gpa: null,
                            from_sat: null,
                            to_sat: null,
                            from_act: null,
                            to_act: null,
                          });
                          formik.handleSubmit();
                        }
                      : null
                  }
                />
                <CardItem
                  onClick={() => setOpenCollegeInfo((prev) => !prev)}
                  label={`College Info ${InfoCount > 0 ? `(${InfoCount})` : ''}`}
                  icon={
                    <SchoolOutlinedIcon color="primary" sx={{ fontSize: 26, marginBottom: 1 }} />
                  }
                  onDelete={
                    InfoCount
                      ? () => {
                          formik.setValues({
                            ...formik.values,
                            region: null,
                            type_of_school: [],
                          });
                          formik.handleSubmit();
                        }
                      : null
                  }
                />
              </Stack>
              <Box
                sx={{ maxHeight: '50dvh', overflowY: 'auto', paddingBottom: '2rem' }}
                className="my-2"
              >
                {(colleges ?? []).map((item, index) => (
                  <Grid
                    container
                    key={index}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                    className="p-2 pt-3 mt-1 border-bottom"
                  >
                    <Grid item md={6}>
                      {item.name}
                    </Grid>
                    <Grid item md={4}>
                      {[item.city, item.state].join(', ')}
                    </Grid>
                    <Grid
                      item
                      md={2}
                      justifyContent="flex-end"
                      display={'flex'}
                      flexDirection={'row'}
                    >
                      <Dropdown>
                        <Dropdown.Toggle>Add to List</Dropdown.Toggle>

                        <Dropdown.Menu>
                          <Dropdown.Header className="text-muted text-wrap" style={{ whiteSpace: 'normal' }}>
                            Lists for {studentName || 'student'}
                          </Dropdown.Header>
                          {(myCurrentList ?? []).length === 0 && (
                            <Dropdown.ItemText className="text-muted small px-3 pb-1">
                              No lists yet — create one below
                            </Dropdown.ItemText>
                          )}
                          {(myCurrentList ?? []).map((currentListItem, currentListIndex) => (
                            <Dropdown.Item
                              key={currentListIndex}
                              onClick={() => handleClickAddToList(item, currentListItem)}
                            >
                              {currentListItem.name}
                            </Dropdown.Item>
                          ))}
                          {myCurrentList?.length < 5 && (
                            <Dropdown.Item onClick={() => setOpenModal(item)}>
                              + Create new list…
                            </Dropdown.Item>
                          )}
                        </Dropdown.Menu>
                      </Dropdown>
                    </Grid>
                  </Grid>
                ))}
              </Box>
            </Card>
          </Box>
        )}
        {colleges?.length ? (
          <Stack className="w-100 m-4" justifyContent="center" direction="row">
            <Pagination
              count={totalPage}
              color="primary"
              page={page}
              onChange={(e, value) => setPage(value)}
            />
          </Stack>
        ) : (
          <Stack className="w-100 m-4" justifyContent="center" direction="row">
            <span>No College found!</span>
          </Stack>
        )}
          <Box sx={{ padding: '0 !important' }}>
            {(myCurrentList ?? []).map((item, indexList) => (
              <div key={indexList}>
                <CardConfig
                  headerElement={
                    <Stack
                      className="w-100"
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                    >
                      <span>{item.name}</span>
                      <Button variant="outline-danger" onClick={() => handleRemoveList(indexList)}>
                        Remove
                      </Button>
                    </Stack>
                  }
                >
                  {item.collegeList.map((miniItem, index) => (
                    <div key={index}>
                      <CollegeInformationDetail
                        allowUpdate
                        miniItem={miniItem}
                        index={index}
                        item={item}
                        handleRemoveSchool={handleRemoveSchool}
                        handleCheckedItem={handleCheckedItem}
                        saveDisabled={saving || loadingLists}
                        studentName={studentName}
                      />
                    </div>
                  ))}
                </CardConfig>
              </div>
            ))}
          </Box>
        </div>
      </Container>
      <ModalAddList
        open={!!openModal?.id}
        handleClose={(str: string) =>
          !str ? setOpenModal(null) : handleAddNewList(str, openModal)
        }
      />
      <ModalMajor open={openMajorSearch} setOpen={setOpenMajorSearch} formik={formik} />
      <ModalLocation open={openLocationSearch} setOpen={setOpenLocationSearch} formik={formik} />
      <ModalCampusLife open={openCampusLife} setOpen={setOpenCampusLife} formik={formik} />
      <ModalAdmissionRequirement
        open={openAdmissionRequirement}
        setOpen={setOpenAdmissionRequirement}
        formik={formik}
      />
      <ModalCollegeInfo open={openCollegeInfo} setOpen={setOpenCollegeInfo} formik={formik} />
    </>
  );
};

export const buildLineRow = (content: (string | ReactNode)[]) => {
  return (
    <Stack className="w-100 py-2" direction="row" justifyContent="space-between">
      <span>{content?.[0]}</span>
      <span>{content?.[1]}</span>
    </Stack>
  );
};
const ModalAddList = ({ open, handleClose }: any) => {
  const formRef = React.useRef(null) as any;
  const [validated, setValidated] = React.useState(true);
  const handleSave = (value: string) => {
    if (!value) {
      setValidated(false);
      return;
    } else {
      handleClose(value);
    }
  };
  return (
    <Modal show={open} onHide={handleClose} centered>
      <Modal.Body>
        <Form
          ref={formRef}
          validated={validated}
          onSubmit={(e) => {
            e.preventDefault();
            handleSave(formRef?.current?.elements[0]?.value);
          }}
        >
          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
            <Form.Label>List Name</Form.Label>
            <Form.Control required autoFocus />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="primary" onClick={() => handleSave(formRef?.current?.elements[0]?.value)}>
          Create List
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

const CardItem = ({ label, onClick, onDelete, icon }: any) => {
  return (
    <Card
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        zIndex: 1,
        cursor: 'pointer',
        width: 132,
      }}
    >
      <Stack
        sx={{
          margin: 1,
          paddingTop: 1,
          height: '80px',
          position: 'relative',
          zIndex: 2,
          fontWeight: 'bold',
        }}
        alignItems="center"
        justifyContent="start"
        onClick={onClick}
      >
        {icon}
        <Box sx={{ textAlign: 'center' }}>{label}</Box>
      </Stack>

      {onDelete && (
        <CancelOutlinedIcon
          onClick={(e) => {
            e.preventDefault();
            onDelete();
          }}
          sx={{
            position: 'absolute',
            top: 3,
            right: 3,
            zIndex: 3,
            cursor: 'pointer',
            fontSize: 16,
            color: 'gray',
          }}
        />
      )}
    </Card>
  );
};

export type CollegeInformationDetailProps = {
  miniItem: TCollege;
  handleRemoveSchool?: any;
  index: number;
  item: any;
  handleCheckedItem?: any;
  allowUpdate?: boolean;
  saveDisabled?: boolean;
  camButton?: ReactNode;
  studentName?: string;
};

export const CollegeInformationDetail = ({
  miniItem,
  handleRemoveSchool,
  index,
  item,
  handleCheckedItem,
  allowUpdate,
  saveDisabled = false,
  camButton,
  studentName,
}: CollegeInformationDetailProps) => {
  const name = studentName?.trim();
  const saveToCollegesLabel = name
    ? `Save to ${name}'s Colleges`
    : 'Save to Student Colleges';
  const cmpsSettingConvert = (str: string | undefined) => {
    let data: any = {
      RURAL: 'Rural',
      SMALL: 'Small Town',
      SUBRB: 'Suburban',
      URBAN: 'Urban',
    };
    return str?.toUpperCase()?.length ? data[str?.toUpperCase()] : '';
  };

  const type_of_school_convert = (str: string | undefined) => {
    let data: any = {
      G: 'Public',
      GCI: 'Public',
      GCO: 'Public',
      GCW: 'Public',
      GDI: 'Public',
      GF: 'Public',
      GP: 'Public',
      GS: 'Public',
      GSL: 'Public',
      GSR: 'Public',
      GT: 'Public',
      P: 'Private',
      PN: 'Private',
      PP: 'Private',
      PR: 'Private',
    };
    return str?.toUpperCase()?.length ? data[str?.toUpperCase()] : '';
  };
  return (
    <CardConfig
      headerElement={
        <Grid
          container
          className="w-100"
          direction="row"
          justifyContent="space-between"
          alignItems={'center'}
        >
          <Grid item md={6} className="px-2">
            {miniItem.name}
          </Grid>
          <Grid
            item
            md={6}
            className="px-2"
            display={'flex'}
            flexDirection={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
          >
            <span>{[miniItem.city, miniItem.state].join(', ')}</span>
            {handleRemoveSchool && (
              <Button
                variant="outline-danger"
                onClick={() => handleRemoveSchool(miniItem, item.name)}
              >
                Remove
              </Button>
            )}
          </Grid>
        </Grid>
      }
    >
      <Row>
        <Stack className="w-100 py-2" 
          direction="row" 
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <span>{miniItem.address_line_1}</span>
          <span>{miniItem.url_address}</span>
          {camButton}
        </Stack>

        {buildLineRow([
          [miniItem.city, miniItem.state, miniItem.zip_code].filter((i) => !!i).join(', '),
          <div>
            {miniItem.url_price_calc ? (
              <a target="_blank" rel="noreferrer" href={miniItem.url_price_calc}>
                Net Price Calculator
              </a>
            ) : (
              'Net Price Calculator Link: N/A'
            )}
          </div>,
        ])}
        {buildLineRow([
          [
            miniItem.year_type,
            type_of_school_convert(miniItem?.type_of_school),
            miniItem?.size_of_school,
            cmpsSettingConvert(miniItem?.cmps_setting),
          ].join(' - '),
          allowUpdate ? (
            <SelectInput
              label={'Counselor Ranking'}
              option={[
                '',
                'Likely',
                'Likely-Target',
                'Target',
                'Target- Reach',
                'Reach',
                'Reach-Far Reach',
                'Far Reach',
              ]}
              mdCol="12"
              values={miniItem.counselor_ranking ?? ''}
              onChange={(e) => {
                const next = e.target.value || undefined;
                if ((miniItem.counselor_ranking || undefined) === next) return;
                handleCheckedItem(
                  { ...miniItem, counselor_ranking: next },
                  index,
                  item.name
                );
              }}
              disabled={saveDisabled}
            />
          ) : (
            <div>
              <div>Counselor Ranking</div>
              <div>{miniItem.counselor_ranking ?? 'N/A'}</div>
            </div>
          ),
        ])}
        {buildLineRow([`GPA Range: ${miniItem?.gpa ?? 'N/A'}`, ''])}
        {buildLineRow([`SAT Range: ${miniItem?.sat ?? 'N/A'}`, ''])}
        {buildLineRow([
          `ACT Average: ${miniItem?.act ?? 'N/A'}`,
          <FormControlLabel
            control={
              <Checkbox
                checked={!!miniItem.is_saved}
                disabled={saveDisabled}
                onChange={(e) =>
                  handleCheckedItem &&
                  handleCheckedItem({ ...miniItem, is_saved: e.target.checked }, index, item.name)
                }
              />
            }
            label={saveToCollegesLabel}
          />,
        ])}
        {/* {buildLineRow([
          '<Admission Rate>',
          <FormControlLabel
            control={
              <Checkbox
                checked={!!miniItem.is_saved}
                onChange={(e) =>
                  handleCheckedItem &&
                  handleCheckedItem({ ...miniItem, is_saved: e.target.checked }, index, item.name)
                }
              />
            }
            label={saveToCollegesLabel}
          />,
        ])} */}
      </Row>
    </CardConfig>
  );
};

export default CounselorCollegeSearch;
